import "./HomeScreen.scss";
import CCSTitle from "../../assets/ccs_title.svg";
import RegisterButton from "../../assets/registerbutton.svg";
import RegisterIllustration from "../../assets/register_illustration.png";
import Timeline from "../../assets/Timeline.svg";
import TimelineMobile from "../../assets/timeline_phone.svg";
import DesignCard from "../../assets/designcard.svg";
import TechCard from "../../assets/techcard.svg";
import MgmtCard from "../../assets/mgmtcard.svg";
import FaqSection from "../../components/Faq/Faq";
import FacebookLogo from "../../assets/facebook.svg";
import InstagramLogo from "../../assets/instagram.svg";
import TwitterLogo from "../../assets/twitter.svg";
import MediumLogo from "../../assets/medium.svg";
import LinkedinLogo from "../../assets/linkedin.svg";
import ACMLogo from "../../assets/acm_logo.svg";
import ACMPixelatedLogo from "../../assets/acm_pixelated_logo.svg";
import Discord from "../../assets/discord.svg";
import useWindowSize from "../../utils/windowSize";
import { useEffect } from "react";
import { useState } from "react";
import Api from "../../utils/api";
import { useSnackbar } from "notistack";

function HomeScreen() {
  const size = useWindowSize();
  const { enqueueSnackbar } = useSnackbar();

  const showErrorSnack = (message) => {
    enqueueSnackbar(message, {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 3000,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  };

  const [displayWidth, setDisplayWidth] = useState(size.width);
  useEffect(() => {
    setDisplayWidth(size.width);
  }, [size]);
  useEffect(() => {
    let errors = localStorage.getItem("err");
    if (errors !== null) {
      localStorage.removeItem("err");
      showErrorSnack(errors);
    }
  });
  const api = new Api();
  return (
    <>
      <div className="homeScreen__header">
        <a
          className="homeScreen__header__logo"
          href="https://acmvit.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={ACMPixelatedLogo} alt="ACM" />
        </a>
        <a
          className="homeScreen__header__discord"
          href="https://discord.com/invite/2yxdXGQB4e"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Discord} alt="Discord" />
        </a>
      </div>
      <div className="homeScreen">
        <div className="homeScreen_mainContainer">
          <div className="homeScreen_mainContainer_registerContainer">
            <div className="homeScreen_mainContainer_registerContainer_left">
              <img
                src={CCSTitle}
                alt="CCS Logo"
                className="homeScreen_mainContainer_registerContainer_left_logo"
              />
              <a href={api.getAuthUrl()}>
                <img
                  src={RegisterButton}
                  alt="Register Button"
                  className="homeScreen_mainContainer_registerContainer_left_registerButton"
                />
              </a>
            </div>
            <div className="homeScreen_mainContainer_registerContainer_right">
              <a href={api.getAuthUrl()}>
                <img
                  src={RegisterIllustration}
                  alt="Register Illustration"
                  className="homeScreen_mainContainer_registerContainer_right_registerIllustration"
                />
              </a>
            </div>
          </div>
          <div className="homeScreen_mainContainer_timelineContainer">
            {displayWidth > 768 ? (
              <img
                src={Timeline}
                alt="Timeline"
                className="homeScreen_mainContainer_timelineContainer_timeline"
              />
            ) : (
              <img
                src={TimelineMobile}
                alt="Timeline"
                className="homeScreen_mainContainer_timelineContainer_timeline"
              />
            )}
          </div>
          <div className="homeScreen_mainContainer_domainsContainer">
            {displayWidth > 768 ? (
              <div className="homeScreen_mainContainer_domainsContainer_domains">
                <img src={DesignCard} alt="Design" />
                <img src={TechCard} alt="Technical" />
                <img src={MgmtCard} alt="Management" />
              </div>
            ) : (
              <div className="homeScreen_mainContainer_domainsContainer_domainsMobile">
                <img
                  src={DesignCard}
                  alt="Design"
                  className="homeScreen_mainContainer_domainsContainer_domainsMobile_domainsTop"
                />
                <img
                  src={TechCard}
                  alt="Technical"
                  className="homeScreen_mainContainer_domainsContainer_domainsMobile_domainsTop"
                />
                <img
                  src={MgmtCard}
                  alt="Management"
                  className="homeScreen_mainContainer_domainsContainer_domainsMobile_domainBottom"
                />
              </div>
            )}
          </div>
          <div className="cc mx-12 sm:mx-20 md:mx-32 lg:mx-40 mb-32">
            **The competition for <b>Competitive Coding</b> will be held from
            9-12pm on 23rd February, 2022 on <b>HackerRank.</b>
          </div>
          <div className="homeScreen_mainContainer_FAQContainer">
            <div className="homeScreen_mainContainer_FAQContainer_title font-futile">
              Got some Questions?
            </div>
            <div className="homeScreen_mainContainer_FAQContainer_subtitle font-spacegrotesk">
              We've got you covered!
            </div>
            <FaqSection />
          </div>
          <div className="homeScreen_mainContainer_footerContainer">
            <div className="homeScreen_mainContainer_footerContainer_white"></div>
            <div className="homeScreen_mainContainer_footerContainer_blue"></div>
            <div className="homeScreen_mainContainer_footerContainer_white_two"></div>
            <div className="homeScreen_mainContainer_footerContainer_social">
              <div className="homeScreen_mainContainer_footerContainer_social_left">
                <a
                  href="https://acmvit.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ACMLogo} alt="ACM Logo" />
                </a>
              </div>
              <div className="homeScreen_mainContainer_footerContainer_social_right">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/acmvitvellore/"
                >
                  <img src={FacebookLogo} alt="Facebook Logo" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://instagram.com/acmvit"
                >
                  <img src={InstagramLogo} alt="Instagram Logo" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://twitter.com/ACM_VIT"
                >
                  <img src={TwitterLogo} alt="Twitter Logo" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://medium.com/acmvit"
                >
                  <img src={MediumLogo} alt="Medium Logo" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/company/acm-vit-chapter/mycompany/"
                >
                  <img src={LinkedinLogo} alt="Linkedin Logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeScreen;
